"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByteArrayFromInteger = exports.getByteArrayFromHexString = exports.createHashValue = exports.createRandomHexValue = void 0;
var Helper = __importStar(require("firefly-utilities-helper-ts"));
var firefly_constants_1 = __importDefault(require("./constants/firefly-constants"));
function createRandomHexValue() {
    var randomNumber = Helper.getRandomNumber(firefly_constants_1.default.PARTITION_MIN_RANDOM, firefly_constants_1.default.PARTITION_MAX_RANDOM);
    // number to hex string
    return randomNumber.toString(firefly_constants_1.default.RADIX_HEX);
}
exports.createRandomHexValue = createRandomHexValue;
function createHashValue() {
    var randomHexValue = createRandomHexValue();
    var timeStamp = Helper.getSystemDate().getTime().toString();
    return randomHexValue + timeStamp;
}
exports.createHashValue = createHashValue;
function getByteArrayFromHexString(hexString) {
    var byte;
    var bytes = [];
    for (var index = 0; index < hexString.length - 1; index += 2) {
        byte = parseInt(hexString.substr(index, 2), 16);
        bytes.push(byte);
    }
    return bytes;
}
exports.getByteArrayFromHexString = getByteArrayFromHexString;
function getByteArrayFromInteger(integer, desiredBytes) {
    var byteValue;
    var byteArray = [];
    for (var index = 0; index < desiredBytes; index += 1) {
        byteValue = integer & firefly_constants_1.default.BYTE_HEX;
        byteArray.push(byteValue);
        integer = (integer - byteValue) / firefly_constants_1.default.BYTE_MAX;
    }
    return byteArray.reverse();
}
exports.getByteArrayFromInteger = getByteArrayFromInteger;
